import { render, staticRenderFns } from "./WashingSymbol.vue?vue&type=template&id=a28bbcba&"
import script from "./WashingSymbol.vue?vue&type=script&lang=js&"
export * from "./WashingSymbol.vue?vue&type=script&lang=js&"
import style0 from "./WashingSymbol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
